const setResult = (
  inputType: "text" | "image",
  inputData: string | File | null,
  result: object
) => {
  if (inputType === "image") {
    // 檢查 inputData 是否為字串 URL
    if (typeof inputData === "string") {
      // 如果是 URL，直接存儲
      const data = JSON.stringify({
        ...result,
        inputType,
        inputData: inputData, // 直接使用 URL 字串
      });
      sessionStorage.setItem("result", data);
    } else if (inputData && typeof inputData === "object") {
      // 如果是 File 或 Blob 物件，使用 FileReader 轉換
      const reader = new FileReader();
      reader.readAsDataURL(inputData);
      reader.onload = () => {
        const base64String = reader.result as string;
        const base64Img = base64String.split(",")[1];
        const data = JSON.stringify({
          ...result,
          inputType,
          inputData: `data:image/jpeg;base64,${base64Img}`,
        });
        sessionStorage.setItem("result", data);
      };
    } else {
      console.error("無效的 inputData 類型:", inputData);
    }
  } else {
    // 文字類型，直接存儲
    const data = JSON.stringify({ ...result, inputType, inputData });
    sessionStorage.setItem("result", data);
  }
};

const getResult = () => {
  const result = JSON.parse(sessionStorage.getItem("result") || "");
  return result;
};

export { setResult, getResult };